import { Modal } from '@chocolate-soup-inc/cs-frontend-components';
import { useState } from 'react';
import styles from './OneOffEventForm.module.scss';
import { readableDate } from '@chocolate-soup-inc/cs-api-consumer-utils';

export const BrickPricing = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <p className={`${styles.fullWidth} ${styles.previewHelp}`}>
        Brick pricing depends on quantity.{' '}
        <button type='button' className={styles.pricingLink} onClick={() => setOpen(true)} aria-haspopup='dialog'>
          View pricing
        </button>
      </p>
      {open && (
        <Modal closeModal={() => setOpen(false)} headline={`Volume Brick Pricing (${readableDate(new Date(), 'yyyy')})`} size='small'>
          <table className={styles.pricingTable}>
            <thead>
              <tr>
                <th scope='col'>Brick Quantity</th>
                <th scope='col'>Unit price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 to 49</td>
                <td>$5.95</td>
              </tr>
              <tr>
                <td>50 to 99</td>
                <td>$5.50</td>
              </tr>
              <tr>
                <td>100 to 199</td>
                <td>$4.10</td>
              </tr>
              <tr>
                <td>200 to 499</td>
                <td>$3.10</td>
              </tr>
              <tr>
                <td>500+</td>
                <td>$2.60</td>
              </tr>
            </tbody>
          </table>
        </Modal>
      )}
    </>
  );
};
